export class Point {
    public x: number;
    public y: number;
    constructor() { }
}


// WEBPACK FOOTER //
// /Users/Sadri/Workspace/Minesweeper/src/app/point.ts